<template>
  <StickyBarContainer
    :id="anchorId"
    ref="sticky-bar"
    :class="[
      variant === 'desktop'
        ? ['hidden lg:block sticky bottom-8 z-30 mt-32 w-full max-w-fit mx-auto md:min-w-[550px]' , desktopIsFloating && 'shadow-[0px_4px_20px_0px_#00000026]']
        : 'block lg:hidden w-full',
    ]">
    <component :is="resolved" v-if="resolved" :item="item" />
  </StickyBarContainer>
</template>

<script setup lang="ts">
import { useStickyBarVisibility } from '@corporate/composables/useStickyBarVisibility'
import { resolveStickyBarVariant } from '@corporate/utils/sticky-bar-variants';
import type { CorporateStickyBarModel } from '@gro-up/api/corporate'
import { computed, onMounted, onUnmounted, useTemplateRef } from 'vue'

import StickyBarContainer from './StickyBarContainer.vue'

type StickyBarBlockProps = CorporateStickyBarModel & { variant: 'mobile' | 'desktop' };

const { variant = 'mobile', stickyType, item } = defineProps<StickyBarBlockProps>()

const stickyBarEl = useTemplateRef('sticky-bar')

const anchorId = computed(() => (variant === 'mobile' ? 'sticky-bar-anchor-mobile' : 'sticky-bar-anchor-desktop'))
const resolved = computed(() => resolveStickyBarVariant(stickyType))

const { observeMobile, unobserveMobile, observeDesktop, unobserveDesktop, desktopIsFloating } = useStickyBarVisibility()

onMounted(() => {
  const el = stickyBarEl.value?.$el
  if (!el) { return }
  if (variant === 'mobile') {
    observeMobile(el)
  } else {
    observeDesktop(el)
  }
})

onUnmounted(() => {
  if (variant === 'mobile') {
    unobserveMobile()
  } else {
    unobserveDesktop()
  }
})
</script>
